import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

const PanelComponent = ({ title, headDetails, children }) => (
	<Col
		md={4}
		sm={6}
		xs={12}
		className="panel-col"
	>
		<div className="panel-head">
			<h4 className="panel-title">{ title }</h4>
			<If condition={headDetails}>
				<div className="panel-head-details">
					<span
						className="panel-head-label"
					>
						{ headDetails }
					</span>
				</div>
			</If>
		</div>
		<div className="panel-content">
			{ children }
		</div>
	</Col>
);

PanelComponent.propTypes = {
	children    : PropTypes.any,
	headDetails : PropTypes.bool,
	title       : PropTypes.string,
};

PanelComponent.defaultProps = {
	children    : undefined,
	headDetails : false,
	title       : '',
};

export default PanelComponent;
